<app-info-panel [isOpen]="isOpen" [title]="title" (closed)="closed.emit()">
  <!-- main section -->
  <app-info-panel-section [columns]="1">
    <app-info-panel-field label="Sample Name" i18n-label [value]="sample?.sampleName" />
    <app-info-panel-field label="Description" i18n-label [value]="sample?.description" />
  </app-info-panel-section>

  <!-- details -->
  <app-info-panel-section [columns]="2">
    <app-info-panel-field label="User Name" i18n-label [value]="sample?.userName" />
    <app-info-panel-field label="Created On" i18n-label [value]="sample?.createdOn | utcDate" />
    <app-info-panel-list-field label="Groups" i18n-label [value]="this.groups" />
  </app-info-panel-section>

  <!-- analysis section -->
  <app-info-panel-expansion-section title="Analyses" i18n-label [columns]="1">
    @if (sample?.analysisNames?.length === 0) {
      <app-info-panel-field value="" />
    }
    @for (analysisName of sample?.analysisNames; track analysisName) {
      <app-info-panel-field value="{{ analysisName }}" />
    }
  </app-info-panel-expansion-section>

  <!-- instrument run section -->
  <app-info-panel-expansion-section title="Instrument Runs" i18n-label [columns]="1">
    @if (sample?.instrumentRunNames?.length === 0) {
      <app-info-panel-field value="" />
    }
    @for (instrumentRun of sample?.instrumentRunNames; track instrumentRun) {
      <app-info-panel-field value="{{ instrumentRun }}" />
    }
  </app-info-panel-expansion-section>
</app-info-panel>
